import Mutation from './mutation';

import { ApolloCache } from 'apollo-client/node_modules/apollo-cache';
import { Apollo } from '$/apollo';
import { Query } from '@graphql/types/client';

export default {
  Mutation,
} as Apollo.Resolvers<ApolloCache<Query>>;
